import React, { useCallback, useState, memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import ClosedIcon from '@material-ui/icons/ClearOutlined'
import OpenIcon from '@material-ui/icons/MoreHorizOutlined'
import SpeedDial from '@material-ui/lab/SpeedDial'
import SpeedDialAction from '@material-ui/lab/SpeedDialAction'
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon'
import LOG from '../../logging/Logger'

const useStyles = makeStyles(theme => ({
  speedDial: {
    zIndex: theme.zIndex.drawer + 1,
    position: 'fixed',
    bottom: theme.spacing(4),
    right: theme.spacing(4)
  }
}))

const useTooltipStyles = makeStyles(theme => ({
  staticTooltipLabel: {
    maxWidth: 'none',
    whiteSpace: 'nowrap'
  }
}))

export default memo(({ actions }) => {
  LOG.debug('Render: TodoSpeedDial')

  const classes = useStyles()

  const [open, setOpen] = useState(false)
  const handleOpen = useCallback(() => {
    setOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  return (
    <SpeedDial
      ariaLabel='SpeedDial toolbar'
      className={classes.speedDial}
      hidden={false}
      icon={<SpeedDialIcon icon={<OpenIcon />} openIcon={<ClosedIcon />} />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
      direction='up'
    >
      {actions.map(action => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          tooltipOpen
          classes={useTooltipStyles()}
          value={action.icon}
          onClick={e => {
            handleClose()
          }}
        />
      ))}
    </SpeedDial>
  )
})
